export default function useGtm() {
  const push = (event: Record<string, unknown>) => {
    if (!import.meta.client) return;

    const w = window as unknown as { dataLayer?: unknown[] };
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push(event);
  };

  return { push };
}
